import { type RefCallback, useEffect, useState } from 'react';

interface ElementHeight<T extends HTMLElement> {
  ref: RefCallback<T>;
  height: number;
}

const useElementHeight = <T extends HTMLElement>(): ElementHeight<T> => {
  const [element, setElement] = useState<T | null>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!element) {
      return;
    }

    const update = () => {
      setHeight(Math.ceil(element.getBoundingClientRect().height));
    };

    update();

    const observer = new ResizeObserver(update);
    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [element]);

  return { ref: setElement, height };
};

export default useElementHeight;
